import React from 'react'
import styled from 'styled-components'
import th from '../../utils/themeHelper'

const ContentContainerForDashForm = styled.div`
  position: relative;
  padding: 0;
  width: 100%;
`

export const ContentContainer = styled.div`
  position: relative;
  padding: 15px 35px 35px;
  flex: 1 1 auto;
  margin-left: ${props => (props.displayFormBar ? 'auto' : '0')};
  margin-right: ${props => (props.displayFormBar ? 'auto' : '0')};
  margin-top: 65px;
  max-width: ${props => props.maxWidth || '1300px'};
  width: 100%;

  @media screen and (max-width: 769px) {
    padding: ${props => (props.padTop ? '0 15px 20px' : '20px 20px 10px')};
    margin-top: 0;
    width: 100%;
  }
`

export const DashLayoutContentContainer = ({ children, displayFormBar, maxWidth, padTop }) => {
  if (!displayFormBar) {
    return (
      <ContentContainer maxWidth={maxWidth} padTop={padTop}>
        {children}
      </ContentContainer>
    )
  }

  return <ContentContainerForDashForm>{children}</ContentContainerForDashForm>
}

export const DashboardContainer = styled.div`
  align-items: flex-start;
  background-color: ${props => (props.isHomePage ? 'white' : th('backgrounds.light'))};
  display: flex;
  flex-wrap: nowrap;
  order: 2;
  padding-left: ${props => (props.displayFormBar ? '0' : '200px')};
  position: relative;

  @media screen and (min-width: 769px) {
    flex: 1;
  }

  @media screen and (max-width: 769px) {
    flex-direction: column;
    width: 100%;
    margin-top: 0;
    padding-left: 0;
  }
`

export const DashboardOverWrapper = styled.div`
  position: relative;
  height: ${props => (props.visibleModal ? '100vh' : 'initial')};
  overflow: ${props => (props.visibleModal ? 'hidden' : 'scroll')};
`

export const DashboardWrapper = styled.div`
  background-color: ${props => (props.isHomePage ? 'white' : th('backgrounds.light'))};
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`

export const DashMenuButton = styled.div`
  padding: 0 6px;
`
